export const clientDataSegmentsFromJSON = (json: IClientDataSegments): IClientDataSegmentsModel => {
	const {
		id,
		client_id,
		email,
		lifetime_orders,
		lifetime_revenue,
		avg_order_value,
		first_order_date,
		last_order_date,
		days_since_last_order,
		orders_90d,
		revenue_90d,
		discount_rate,
		used_promo_ever,
		preferred_payment_method,
		payment_success_rate,
		avg_days_between_orders,
		rfm_recency_days,
		rfm_frequency,
		rfm_monetary,
		recency_score,
		frequency_score,
		revenue_score,
		rfm_total_score,
		wealth_index,
		high_value_client_flag,
		churn_risk_flag,
		top_diet_id,
		top_meal_id,
		sync_at,
		created_at,
		updated_at,
		top_meal_name,
		client_segment,
		diet,
	} = json

	return {
		id,
		email,
		diet,
		clientId: client_id,
		lifetimeOrders: lifetime_orders,
		lifetimeRevenue: lifetime_revenue,
		avgOrderValue: avg_order_value,
		firstOrderDate: first_order_date,
		lastOrderDate: last_order_date,
		daysSinceLastOrder: days_since_last_order,
		orders90d: orders_90d,
		revenue90d: revenue_90d,
		discountRate: discount_rate,
		usedPromoEver: used_promo_ever,
		preferredPaymentMethod: preferred_payment_method,
		paymentSuccessRate: payment_success_rate,
		avgDaysBetweenOrders: avg_days_between_orders,
		rfmRecencyDays: rfm_recency_days,
		rfmFrequency: rfm_frequency,
		rfmMonetary: rfm_monetary,
		recencyScore: recency_score,
		frequencyScore: frequency_score,
		revenueScore: revenue_score,
		rfmTotalScore: rfm_total_score,
		wealthIndex: wealth_index,
		highValueClientFlag: high_value_client_flag,
		churnRiskFlag: churn_risk_flag,
		topDietId: top_diet_id,
		topMealId: top_meal_id,
		syncAt: sync_at,
		createdAt: created_at,
		updatedAt: updated_at,
		topMealName: top_meal_name,
		clientSegment: client_segment,
	}
}
